import { useEffect, useState } from 'react';
import { Storage } from 'aws-amplify';
import aws_config from '../modified_aws-export';

export const useFetchImages = (fileName: string) => {
    const [img, setImg] = useState<string | undefined>(undefined);
    const [imgTA, setImgTA] = useState<string | undefined>(undefined);

    useEffect(() => {
        Storage.configure({
            aws_user_files_s3_bucket_region: aws_config.backend.region,
            aws_user_files_s3_bucket: aws_config.backend.bucket_name
        });

        const fetchImages = async () => {
            const config: any = { level: 'public', customPrefix: { public: '' } };

            try {
                const omeImg = await Storage.get(fileName, { ...config });
                setImg(omeImg);

                if (fileName.includes("OEM")) {
                    const taImg = await Storage.get(fileName.replace('OEM', 'TA'), { ...config });
                    setImgTA(taImg);
                }
            } catch (error) {
                console.error("Error fetching images", error);
            }
        };

        fetchImages();
    }, [fileName]);

    return { img, imgTA };
};

export const fetchImages = async (fileName: string) => {
    const config: any = {
        bucket: aws_config.aws_user_files_s3_bucket,
        region: aws_config.aws_user_files_s3_bucket_region, level: 'public', customPrefix: { public: '' }
    };

    try {
        return await Storage.get(fileName, { ...config });

    } catch (error) {
        console.error("Error fetching images", error);
    }
}
